import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import Aura from '@primevue/themes/aura';
import './styles/theme.css';
import { i18n } from './locales/i18n';

const app = createApp(App);
const pinia = createPinia();
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: 'app-dark'
        }
    }
});

app.directive('tooltip', Tooltip);
app.use(pinia);
app.use(i18n);
app.mount('#app');
